<template>
  <div ref="container" class="cms" />
</template>

<script>
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import preset, { enumStyleFormat } from '@mc/tangram-preset-h5'
import { baichuanAdapter } from '@/common/cms/adapters/baichuan'
import { Coupons } from '@/common/cms/modules/coupons/module/index'
import { templateCouponsVue } from '@/common/cms/modules/coupons/template'
import { cmsRedirect } from '@/common/cms/cms_redirect'
import { checkWebp } from '@/utils/check_webp'
import { trackRoutesMap } from '../../../../utils/tracer/routes_map'

export default {
  name: 'CMS',
  async created() {
    const webp = await checkWebp()
    // 这个 cms 实例就是为了保存一下用的方便，不需要响应式，所以不用 $set
    this.cms = preset({
      baseWidth: window.innerWidth * 2,
      expectFormat: enumStyleFormat.CamelCase,
      adapters: [
        data => {
          data.style.pt = 88
          return data
        },
        baichuanAdapter
      ],
      webp,
      useExposeTrack: true,
      expose: {
        callback: target => {
          if (target?.data?.click && target?.data?.data) {
            const spm = target.data.click.spm
            const params = Object.assign(
              {},
              target.data.click.spmJson,
              target.data.data
            )
            tracerVuePlugin.request({
              spm,
              type: 8,
              params,
              page_id: trackRoutesMap['#/category_area/frozen'].pageId
            })
          }
        }
      }
    })
    this.cms.addModule({
      module: Coupons,
      moduleName: 'coupons',
      template: templateCouponsVue,
      renderIdentifier: 'coupons'
    })
    this.cms.addEventListener(this.cms.instance.Events.REDIRECT, evt => {
      cmsRedirect(evt)
    })
  },
  methods: {
    render(data) {
      if (this.cms) {
        this.cms.setData(data)
        this.cms.render(this.$refs.container)
      } else {
        setTimeout(() => {
          this.cms.setData(data)
          this.cms.render(this.$refs.container)
        }, 0)
      }
    }
  }
}
</script>
